/**
 * ProductListing.js — Paginated product grid wrapper.
 *
 * Slices the full product array to the current page window and renders a
 * ProductGridNew card for each item. Reports the total product count back to
 * the parent via statehandler so pagination can be updated.
 *
 * Props:
 *  - data {Array}                     Full product list from the parent.
 *  - pageSize {number}                Number of products per page.
 *  - currentPage {number}             Active page index (1-based).
 *  - statehandler {Function}          Callback that receives the total product count.
 *  - GAurl {string}                   Google Ads query string appended to links.
 *  - Program_structure_images {Array} Slug-to-image mapping for card thumbnails.
 *  - AddtoCart {Function}             Adds a variant to the Shopify cart.
 *  - AddtoWishlist {Function}         Toggles a product in the wishlist.
 *  - getAllWishlist {Array}            Current wishlist product slugs.
 *  - is_ten_minite_less {Function}    Returns true if event starts in <10 min.
 *  - program_date_is_gone_or_not {Function} Returns true if event date has passed.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';

// ─── Single source of truth for card design ───────────────────────────────────
import ProductGridNew from './ProductGrid/ProductGridNew';

/**
 * Renders a paginated slice of products as ProductGridNew cards.
 * Returns a "no programs found" message when the current page slice is empty.
 */
export const ProductListing = (props) => {

  /***
   * Values from Parent component
   */
  const totalProduct = props.data.length;
  const offset = (props.currentPage - 1) * props.pageSize;
  const nextt = props.currentPage * props.pageSize;
  const newdata = props.data.slice(offset, nextt);
  const { statehandler } = props;

  /***
   * Return total product to main component
   */

  useEffect(() => {
      statehandler(totalProduct);
  }, [totalProduct, statehandler]);

  const randm = () => {
    return (Math.random() + 1).toString(36).substring(7);
  };

  if (newdata.length === 0) {
    return (
      <div><h4>No programs could be found under the current search criteria</h4></div>
    );
  }

  return newdata.map(products => {
    let product = Object.values(products)[1];
    return (
      <Col key={randm()} lg={3} md={6} xs={12}>
        <ProductGridNew
          product={product}
          GAurl={props.GAurl}
          Program_structure_images={props.Program_structure_images}
          AddtoCart={props.AddtoCart}
          is_ten_minite_less={props.is_ten_minite_less}
          program_date_is_gone_or_not={props.program_date_is_gone_or_not}
          AddtoWishlist={props.AddtoWishlist}
          getAllWishlist={props.getAllWishlist}
          EngineURL={props.EngineURL}
        />
      </Col>
    );
  });
}
